import { render } from "./localLogin.vue?vue&type=template&id=467d1bd5&scoped=true"
import script from "./localLogin.vue?vue&type=script&lang=js"
export * from "./localLogin.vue?vue&type=script&lang=js"

import "./localLogin.vue?vue&type=style&index=0&id=467d1bd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467d1bd5"]])

export default __exports__